import React from "react";
import { Button, Modal } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useCreateNoteMutation, useUpdateNoteMutation } from "store/services/V2/notes";
import { successMessageToast } from "helpers/common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";

// Validation Schema
const validationSchema = Yup.object({
  note: Yup.string()
    .trim()
    .required("Note is required")
    .max(500, "Note must be at most 500 characters"),
});

const AddNotesModal = ({
  title,
  message,
  onCancel,
  confirmBtnText = "Save",
  cancelBtnText = "Cancel",
  show,
  setShow,
  currentEntry,
  setCurrentEntry
}) => {
  const [createNote, { isLoading: createNotesLoading }] = useCreateNoteMutation();
  const [updateNote, { isLoading: updateNotesLoading }] = useUpdateNoteMutation();

  const { clientId, moduleName } = useParams()

  const handleClose = () => {
    setShow(false);
    setCurrentEntry(false)
  };

  const handleSubmit = async (values, { resetForm }) => {
    const data = {
      note: values?.note,
      client_id: clientId,
      module: moduleName
    }
    try {
      const result = currentEntry?.id ? updateNote(data).unwrap() : await createNote(data).unwrap();
      successMessageToast(result?.message);
      resetForm();
      handleClose();
    } catch (error) {
      console.error("Error creating note:", error);
    }
  };

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        {createNotesLoading && <LoadingOverlay />}
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderColor: "rgb(49, 93, 153)" }}
          >
            <h3
              className={`${styles.modalMessage} mb-0 pb-0 section-title border-bottom-0`}
              style={{ color: "rgb(49, 93, 153)", fontSize: "14px" }}
            >
              {currentEntry?.id ? "EDIT NOTE" : "CREATE NOTE"}
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Formik Form */}
          <Formik
            initialValues={{ note: currentEntry?.note ? currentEntry?.note : "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                {/* Textarea Field */}
                <div className="mt-3">
                  <AppInputField
                    fieldType={'textarea'}
                    name="note"
                    className="readonly-box w-100 p-2"
                    placeholder="Enter text..."
                    rows={4}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      resize: "none",
                    }}
                  />
                </div>

                {/* Optional Message */}
                {message && (
                  <p
                    className="my-2 proxmia-thin text-start fw-bold"
                    style={{ fontSize: "16px", color: "#505C6D" }}
                  >
                    {message}
                  </p>
                )}

                {/* Buttons */}
                <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center">
                  <div className="px-2">
                    <Button
                      onClick={handleClose}
                      className={`${styles.modalButton} proxima-regular`}
                      style={{
                        border: "1px solid rgb(49, 93, 153)",
                        background: "white",
                        color: "#315D99",
                        padding: "8px 38px",
                        borderRadius: 2,
                      }}
                      disabled={isSubmitting}
                    >
                      {cancelBtnText}
                    </Button>
                  </div>
                  <div className="px-2">
                    <Button
                      type="submit"
                      className={`${styles.modalButton} proxima-regular`}
                      style={{
                        backgroundColor: "rgb(49, 93, 153)",
                        color: "#fff",
                        padding: "8px 38px",
                        borderRadius: 2,
                        border: 0,
                      }}
                      disabled={isSubmitting || createNotesLoading}
                    >
                      {confirmBtnText}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddNotesModal;
